import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

export function initTime() {
  dayjs.extend(quarterOfYear);
}
